// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router';
import useAuth from '../hooks/useAuth';

export default function ProtectedRoute({ children }) {
  const { user, loadingUser } = useAuth();
  const location = useLocation();

  if (loadingUser) {
    // show spinner while checking
    return <div>Loading...</div>;
  }

  if (!user) {
    const next = `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }

  return children;
}
